import { render, staticRenderFns } from "./SelectedInfo.vue?vue&type=template&id=4ec30d03"
import script from "./SelectedInfo.vue?vue&type=script&lang=js"
export * from "./SelectedInfo.vue?vue&type=script&lang=js"
import style0 from "./SelectedInfo.vue?vue&type=style&index=0&id=4ec30d03&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports